import { AxiosError } from 'axios'
import { toast } from 'react-toastify'
import { createQuickMessages } from '../../actions/ai';

type GenerateQuickMessagesProps = {
  filename: string
  prompt: string
  createQuickMessagesUrl?: string
  quickMessages: string[]
  usedQuickMessages: string[]
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
  setQuickMessages: React.Dispatch<React.SetStateAction<string[]>>
  setUsedQuickMessages: React.Dispatch<React.SetStateAction<string[]>>
};

const MAX_USED = 10; // history of used messages limited to 10
const MAX_MSGS = 5; // max quick messages to show at a given time
const generateQuickMessages = async ({
  filename,
  prompt,
  createQuickMessagesUrl,
  quickMessages,
  usedQuickMessages,
  setLoading,
  setQuickMessages,
  setUsedQuickMessages
}: GenerateQuickMessagesProps) => {
  try {
    setLoading(true);
    
    if (prompt !== '') { // remove from quickmessages and add it to the used list
      setQuickMessages(quickMessages.filter(item => item !== prompt));
      
      if (usedQuickMessages.length >= MAX_USED) {
        setUsedQuickMessages([...usedQuickMessages.slice(1), prompt]);
      } else {
        setUsedQuickMessages([...usedQuickMessages, prompt]);
      }
    }else{
      const formattedFilename = filename.replace(/ /g, '_')
      const result = await createQuickMessages(
        formattedFilename, 
        {
          messages: usedQuickMessages,
        },
        createQuickMessagesUrl
      );
      const quickMessagesArray = (result.response)?.split(" | ") || "";
      setQuickMessages(quickMessagesArray);
    }

    // regenerate quick messages if less than max
    if (quickMessages.length <= MAX_MSGS) {
      const formattedFilename = filename.replace(/ /g, '_')

      const result = await createQuickMessages(formattedFilename, 
        {
        messages: usedQuickMessages,
        },
        createQuickMessagesUrl  
      );
      const quickMessagesArray = (result.response)?.split(" | ") || "";
      setQuickMessages([...quickMessages, ...quickMessagesArray]);
    }
    
  } catch (err) {
    if (err instanceof AxiosError) {
      toast.error(err.response?.data.message ?? err.message);
    }
    return Promise.reject(err);
  } finally {
    setLoading(false);
  }
};

export default generateQuickMessages;